import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useMenu } from "hook/useMenu";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import UsageSignupPresenter from "./UsageSignupPresenter";
import useUsageSignupFlow from "./useUsageSignupFlow";

export default function UsageSignupContainer(): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { buildEntryNavigateProps } = useMenu({});
  const flow = useUsageSignupFlow({});

  if (selectedAccount.isUsagePaid) {
    return (
      <Navigate
        {...buildEntryNavigateProps("/subscription/usage/organization")}
        replace
      />
    );
  }

  return (
    <UsageSignupPresenter
      flow={flow}
      onAddPayment={flow.actions.onAddPayment}
    />
  );
}
